import AnalyticsService from "@/api/services/analytics";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  generalAnalytics: {},
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    generalData: (state) => state.generalAnalytics?.general,
    previousPeriodStartDate: (state) => state.generalAnalytics?.previousPeriod?.startDate,
  },
  mutations: {
    setGeneralAnalytics(state, data) {
      state.generalAnalytics = data;
    },
  },
  actions: {
    async fetchGeneralAnalytics({ commit }, params) {
      const response = await AnalyticsService.getGeneralAnalytics(params);
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setGeneralAnalytics", data.analytics);
      return data;
    },
    async getOrganizations(_, { startDate, endDate }) {
      return await AnalyticsService.getOrganizations(startDate, endDate);
    },
    async getStores(_, { organizationId, startDate, endDate }) {
      return await AnalyticsService.getStores(organizationId, startDate, endDate);
    },
    async getSellers(_, { storeId, startDate, endDate }) {
      return await AnalyticsService.getSellers(storeId, startDate, endDate);
    },
  },
};
